import React, { useEffect } from "react";
import { trackEvent } from "services/analytics";

const createWidget = (formid) => {
	const container = document.querySelector("#typeform");

	if (container) {
		window.tf.createWidget(formid, {
			container,
			onSubmit: ({ formId, responseId }) => {
				trackEvent("typeform_submitted", { formId, responseId });
			},
		});
	}
};

const loadScript = (formid) => {
	// Check if the script already exists
	if (document.querySelector(`script[src="//embed.typeform.com/next/embed.js"]`)) {
		createWidget(formid); // Script is already loaded, directly create the widget
		return;
	}

	const script = document.createElement("script");
	script.src = "//embed.typeform.com/next/embed.js";
	script.async = true;

	const styleLink = document.createElement("link");
	styleLink.rel = "stylesheet";
	styleLink.href = "//embed.typeform.com/next/css/popup.css";

	script.onload = () => {
		createWidget(formid);
	};

	document.body.appendChild(script);
	document.body.appendChild(styleLink);
};

const TypeForm = ({ data }) => {
	useEffect(() => {
		if (data?.id) {
			loadScript(data.id);
		}
	}, []);

	return <div id="typeform" className="typeform-module min-h-[75vh]" />;
};

export default TypeForm;
